"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DirectionRight_1 = require("../Icons/DirectionRight");
var select_1 = tslib_1.__importDefault(require("../select"));
var Panel_1 = tslib_1.__importDefault(require("./Panel"));
var Selection_1 = tslib_1.__importDefault(require("./Selection"));
var utils_1 = require("./utils");
var Checkable = function (props) {
    var _a, _b, _c, _d;
    var _e = props.selectedKeys, selectedKeys = _e === void 0 ? [] : _e, _f = props.titles, titles = _f === void 0 ? [] : _f, dataSource = props.dataSource, className = props.className, hasFilter = props.hasFilter, hideResultPanel = props.hideResultPanel, hideTitle = props.hideTitle, onChange = props.onChange, _g = props.type, type = _g === void 0 ? 'panel' : _g, disabled = props.disabled, _h = props.size, size = _h === void 0 ? 'middle' : _h, error = props.error, _j = props.style, style = _j === void 0 ? {} : _j, _k = props.lastPanelStyle, lastPanelStyle = _k === void 0 ? {} : _k, _l = props.placement, placement = _l === void 0 ? 'bottomLeft' : _l, renderCell = props.renderCell, rest = tslib_1.__rest(props, ["selectedKeys", "titles", "dataSource", "className", "hasFilter", "hideResultPanel", "hideTitle", "onChange", "type", "disabled", "size", "error", "style", "lastPanelStyle", "placement", "renderCell"]);
    var depthDataSourceRef = (0, react_1.useRef)([]);
    var depthSelectedKeysRef = (0, react_1.useRef)(selectedKeys);
    var _m = tslib_1.__read((0, react_1.useState)(selectedKeys), 2), depthSelectedKeys = _m[0], setSelectedKeys = _m[1];
    var _o = tslib_1.__read((0, react_1.useState)([]), 2), setFocusKeys = _o[1];
    var depthFocusKeysRef = (0, react_1.useRef)([]);
    var isCheckingParentRef = (0, react_1.useRef)(false);
    var isCheckingChildren = (0, react_1.useRef)(false);
    var defaultItem = (0, react_1.useMemo)(function () { return ({ isSelected: false, indeterminate: false }); }, []);
    var depth = (0, react_1.useMemo)(function () {
        return (0, utils_1.getDataDepth)(dataSource);
    }, [dataSource]);
    var reverseTitles = (0, react_1.useMemo)(function () {
        return (titles || []).reverse();
    }, [titles]);
    var changeDataSourceStatus = (0, react_1.useCallback)(function (keys, depthDataSource) {
        depthDataSource.map(function (item, index) {
            var key = item.key;
            depthDataSource[index].isSelected = keys.includes(key);
        });
    }, []);
    var updateSelectedKeys = (0, react_1.useCallback)(function (item) {
        var key = item.key, isSelected = item.isSelected;
        if (key) {
            var keys = void 0;
            if (isSelected) {
                keys = Array.from(new Set(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(depthSelectedKeysRef.current), false), [key], false)));
            }
            else {
                keys = depthSelectedKeysRef.current.filter(function (item) { return item !== key; });
            }
            depthSelectedKeysRef.current = tslib_1.__spreadArray([], tslib_1.__read(keys), false);
            setSelectedKeys(tslib_1.__spreadArray([], tslib_1.__read(depthSelectedKeysRef.current), false));
        }
    }, []);
    var updateFocusKeys = (0, react_1.useCallback)(function (item) {
        var key = item.key, isFocus = item.isFocus;
        if (!key) {
            return;
        }
        var keys;
        if (isFocus) {
            keys = Array.from(new Set(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(depthFocusKeysRef.current), false), [key], false)));
        }
        else {
            keys = depthFocusKeysRef.current.filter(function (item) { return item !== key; });
        }
        depthFocusKeysRef.current = tslib_1.__spreadArray([], tslib_1.__read(keys), false);
        setFocusKeys(keys);
    }, []);
    var getExpandable = (0, react_1.useCallback)(function (depth, defaultFocus) {
        if (defaultFocus === void 0) { defaultFocus = false; }
        return depth > 0
            ? {
                expandedRowRender: function (dataSource, parentRecord) {
                    var _a, _b;
                    if (!dataSource || dataSource.length === 0) {
                        return react_1.default.createElement(react_1.default.Fragment, null);
                    }
                    return (react_1.default.createElement(Panel_1.default, { dataSource: dataSource, title: reverseTitles[depth - 1], hasFilter: hasFilter, className: className, lastPanelStyle: lastPanelStyle, onchange: function (keys) { return changeDataSourceStatus(keys, dataSource); }, hideTitle: hideTitle, rowSelection: {
                            selectedRowKeys: depthSelectedKeysRef.current,
                            focusKeys: (_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.filter(function (_a) {
                                var isFocus = _a.isFocus;
                                return isFocus;
                            })) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
                                var key = _a.key;
                                return key;
                            }),
                            indeterminateRowKeys: (_b = dataSource === null || dataSource === void 0 ? void 0 : dataSource.filter(function (_a) {
                                var indeterminate = _a.indeterminate;
                                return indeterminate;
                            })) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                                var key = _a.key;
                                return key;
                            }),
                            renderCell: renderCell,
                        }, defaultFocus: defaultFocus, expandable: getExpandable(depth - 1, defaultFocus), parentRecord: parentRecord }));
                },
            }
            : undefined;
    }, [reverseTitles, hasFilter, className, hideTitle, changeDataSourceStatus]);
    var checkingChildrenHasDisabled = function (children) {
        var hasDisabled = false;
        var loopItem = function (items) {
            var e_1, _a;
            if (!items) {
                return;
            }
            try {
                for (var items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                    var _b = items_1_1.value, disabled_1 = _b.disabled, children_1 = _b.children;
                    if (disabled_1) {
                        hasDisabled = true;
                        break;
                    }
                    else {
                        loopItem(children_1);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        loopItem(children);
        return hasDisabled;
    };
    var doWatch = (0, react_1.useCallback)(function (dataSource, parent) {
        var handle = {
            get: function (target, key) {
                return target[key];
            },
            set: function (target, key, value) {
                if (target[key] === value) {
                    return true;
                }
                var children = target.children;
                Reflect.set(target, key, value);
                if (key === 'isSelected' || key === 'indeterminate') {
                    updateSelectedKeys(target);
                    // Checking Children is selected.
                    if (!isCheckingParentRef.current && key === 'isSelected') {
                        isCheckingChildren.current = true;
                        children === null || children === void 0 ? void 0 : children.forEach(function (_ele, index) {
                            var disabled = children[index].disabled;
                            if (!disabled) {
                                children[index].isSelected = value;
                                updateSelectedKeys(children[index]);
                            }
                        });
                        isCheckingChildren.current = false;
                    }
                    // Checking Parent is selected.
                    if (parent && !isCheckingChildren.current) {
                        isCheckingParentRef.current = true;
                        var _a = (0, utils_1.getStatusOfCheck)(dataSource), numberOfChecked = _a.numberOfChecked, numberOfIndeterminate = _a.numberOfIndeterminate, numberOfActiveItem = _a.numberOfActiveItem;
                        parent.isSelected = numberOfChecked > 0 && numberOfChecked === numberOfActiveItem;
                        parent.indeterminate =
                            !parent.isSelected && (numberOfChecked > 0 || numberOfIndeterminate > 0);
                        updateSelectedKeys(parent);
                    }
                    isCheckingParentRef.current = false;
                }
                if (key === 'isFocus') {
                    updateFocusKeys(target);
                }
                return true;
            },
        };
        dataSource === null || dataSource === void 0 ? void 0 : dataSource.forEach(function (element, index) {
            var children = dataSource[index].children;
            dataSource[index].hasDisabled = checkingChildrenHasDisabled(children);
            dataSource[index] = new Proxy(tslib_1.__assign(tslib_1.__assign({}, defaultItem), element), handle);
            doWatch(children, dataSource[index]);
        });
        if (parent && dataSource) {
            dataSource.parent = parent;
        }
    }, []);
    var selectedTitle = (0, react_1.useMemo)(function () {
        (0, utils_1.checkSelectStatus)(dataSource, depthSelectedKeysRef.current);
        var parentStack = [];
        var renderItems = [];
        var loopForItem = function (dataSource) {
            dataSource.map(function (item) {
                var isSelected = item.isSelected, indeterminate = item.indeterminate, children = item.children;
                if (isSelected) {
                    renderItems.push(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(parentStack), false), [item], false));
                }
                else if (indeterminate) {
                    parentStack.push(item);
                    loopForItem(children);
                    parentStack.pop();
                }
            });
        };
        loopForItem(dataSource);
        var selectedTitle = renderItems.map(function (arr) {
            return arr.reduce(function (pre, cur) {
                var title = cur.title, key = cur.key;
                var _a = pre, value = _a.value, label = _a.label;
                return {
                    label: label ? (react_1.default.createElement(react_1.default.Fragment, null,
                        label,
                        react_1.default.createElement(DirectionRight_1.DirectionRight, { className: "anq-cascader-select-title-icon anq-cascader-select-title-icon-".concat(size) }),
                        title)) : (title),
                    key: value ? "".concat(value, "/").concat(key) : key,
                };
            }, {});
        });
        return selectedTitle;
    }, [dataSource, depthSelectedKeys, size]);
    var onSelectedKeyChanged = function (keys) {
        depthSelectedKeysRef.current = keys;
        setSelectedKeys(depthSelectedKeysRef.current);
    };
    var onSelectChange = (0, react_1.useCallback)(function (selectedItems) {
        var currentKeys = selectedTitle.map(function (_a) {
            var key = _a.key;
            return key;
        });
        selectedItems.map(function (item) {
            var key = item.key;
            currentKeys = currentKeys.filter(function (currentKey) { return currentKey !== key; });
        }, []);
        var patchedKey = currentKeys[0];
        var loop = function (dataSource) {
            if (dataSource && dataSource.length) {
                dataSource.forEach(function (element) {
                    var key = element.key, children = element.children;
                    if (key === patchedKey) {
                        element.isSelected = false;
                    }
                    else {
                        loop(children);
                    }
                });
            }
        };
        loop(depthDataSourceRef.current);
    }, [selectedTitle]);
    var onSelectClear = (0, react_1.useCallback)(function () {
        var loop = function (dataSource) {
            dataSource.forEach(function (item) {
                item.isSelected = false;
                item.children && loop(item.children);
            });
        };
        loop(depthDataSourceRef.current);
    }, []);
    (0, react_1.useEffect)(function () {
        if (onChange) {
            onChange(depthSelectedKeys);
        }
    }, [depthSelectedKeys]);
    (0, react_1.useEffect)(function () {
        var clonedDataSource = (0, utils_1.cloneDeep)(dataSource);
        (0, utils_1.checkSelectStatus)(clonedDataSource, selectedKeys);
        doWatch(clonedDataSource);
        depthSelectedKeysRef.current = selectedKeys;
        depthDataSourceRef.current = tslib_1.__spreadArray([], tslib_1.__read(clonedDataSource), false);
        setSelectedKeys(tslib_1.__spreadArray([], tslib_1.__read(depthSelectedKeysRef.current), false));
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        type === 'panel' && (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-cascader'), style: style },
            react_1.default.createElement("div", { className: "anq-selectable-container" },
                react_1.default.createElement(Panel_1.default, { dataSource: depthDataSourceRef.current, title: reverseTitles[depth - 1], className: className, lastPanelStyle: lastPanelStyle, hasFilter: hasFilter, hideTitle: hideTitle, rowSelection: {
                        hideSelectAll: false,
                        selectedRowKeys: depthSelectedKeysRef.current,
                        focusKeys: (_b = (_a = depthDataSourceRef.current) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
                            var isFocus = _a.isFocus;
                            return isFocus;
                        })) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                            var key = _a.key;
                            return key;
                        }),
                        indeterminateRowKeys: (_d = (_c = depthDataSourceRef.current) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
                            var indeterminate = _a.indeterminate;
                            return indeterminate;
                        })) === null || _d === void 0 ? void 0 : _d.map(function (_a) {
                            var key = _a.key;
                            return key;
                        }),
                        renderCell: renderCell,
                    }, onchange: function (keys) { return changeDataSourceStatus(keys, depthDataSourceRef.current); }, expandable: getExpandable(depth - 1), depth: 1 }, !hideResultPanel && (react_1.default.createElement(Selection_1.default, { selectedKeys: depthSelectedKeysRef.current, dataSource: depthDataSourceRef.current, className: className, onChange: onSelectedKeyChanged })))))),
        type === 'select' && (react_1.default.createElement(select_1.default, tslib_1.__assign({ placeholder: "\u8BF7\u9009\u62E9", size: size, error: error, mode: "multiple", labelInValue: true, value: selectedTitle, className: "anq-select-cascader", dropdownClassName: "anq-select-cascader-dropdown", onChange: onSelectChange, allowClear: true, onClear: onSelectClear, dropdownStyle: { minWidth: 100 }, disabled: disabled, style: style, placement: placement }, rest, { dropdownRender: function () {
                var _a, _b, _c, _d;
                return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-cascader') },
                    react_1.default.createElement("div", { className: "anq-selectable-container" },
                        react_1.default.createElement(Panel_1.default, { dataSource: depthDataSourceRef.current, title: reverseTitles[depth - 1], className: className, lastPanelStyle: lastPanelStyle, hasFilter: hasFilter, hideTitle: hideTitle, rowSelection: {
                                hideSelectAll: false,
                                selectedRowKeys: depthSelectedKeysRef.current,
                                focusKeys: (_b = (_a = depthDataSourceRef.current) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
                                    var isFocus = _a.isFocus;
                                    return isFocus;
                                })) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                                    var key = _a.key;
                                    return key;
                                }),
                                indeterminateRowKeys: (_d = (_c = depthDataSourceRef.current) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
                                    var indeterminate = _a.indeterminate;
                                    return indeterminate;
                                })) === null || _d === void 0 ? void 0 : _d.map(function (_a) {
                                    var key = _a.key;
                                    return key;
                                }),
                                renderCell: renderCell,
                            }, onchange: function (keys) { return changeDataSourceStatus(keys, depthDataSourceRef.current); }, expandable: getExpandable(depth - 1), depth: 1 }))));
            } })))));
};
exports.default = Checkable;
//# sourceMappingURL=Checkable.js.map